import { FIND_IMAGE_FAILURE, FIND_IMAGE_REQUEST, FIND_IMAGE_SUCCESS, FIND_PRODUCT_BY_CATEGORY_FAILURE, FIND_PRODUCT_BY_CATEGORY_REQUEST, FIND_PRODUCT_BY_CATEGORY_SUCCESS, FIND_PRODUCT_BY_ID_FAILURE, FIND_PRODUCT_BY_ID_REQUEST, FIND_PRODUCT_BY_ID_SUCCESS } from "./ActionType"

const initialState = {
    products: [],
    colors:null,
    sizes:null,
    product: null,
    loading: false,
    error: null
}
export const CustommerProductReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case FIND_PRODUCT_BY_CATEGORY_REQUEST:
        case FIND_IMAGE_REQUEST:
        case FIND_PRODUCT_BY_ID_REQUEST:
            return { ...state, loading: true, error: null }
        case FIND_PRODUCT_BY_CATEGORY_SUCCESS:
            
            state.products = action.payload.products;
            state.colors = action.payload.colors;
            state.sizes = action.payload.sizes;


            return { ...state, loading: false, error: null }
        case FIND_PRODUCT_BY_ID_SUCCESS:
            return { ...state, loading: false, error: null, product: action.payload }
        case FIND_IMAGE_SUCCESS:
            state.product.imageUrl = [];
            state.product.sizes = [];
            state.product.imageUrl = action.payload.imageUrl;
            state.product.sizes = action.payload.sizes;

            return { ...state, loading: false, error: null }

        case FIND_PRODUCT_BY_CATEGORY_FAILURE:
        case FIND_IMAGE_FAILURE:
        case FIND_PRODUCT_BY_ID_FAILURE:
            return { ...state, loading: false, error: action.payload }
        default:
            return state;
    }
}